/**
 * Channel Service 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VirtualWarehouseDTO } from './virtualWarehouseDTO';


/**
 * Online Store
 */
export interface OnlineShopDetailVO { 
    creationDate?: string;
    lastUpdateDate?: string;
    createdBy?: string;
    lastUpdatedBy?: string;
    objectVersionNumber?: number;
    id?: number;
    code?: string;
    tenantId?: number;
    name?: string;
    channelTypeCode?: string;
    channelType?: string;
    channelPlatform?: string;
    channelTypeMeaning?: string;
    onlineStoreTypeCode?: string;
    onlineStoreTypeMeaning?: string;
    /**
     * Person in charge
     */
    manager?: string;
    /**
     * Online store address (url)
     */
    url?: string;
    salesOrganizingId?: number;
    invoiceTypeCode?: string;
    invoiceTypeCodeMeaning?: string;
    description?: string;
    /**
     * Channel warehouse usage status, true is
     */
    channelWarehouseStatus?: boolean;
    channelWarehouseName?: string;
    deleteFlag?: boolean;
    /**
     * Status: true-enable
     */
    status?: boolean;
    /**
     * Automatic shipment confirmation (days)
     */
    autoConfirmDay?: number;
    /**
     * Automatically download products: true-yes false-no
     */
    autoDownloadGoods?: boolean;
    /**
     * Automatically synchronize inventory: true-yes false-no
     */
    autoSyncInventory?: boolean;
    /**
     * Store ID associated with the online store
     */
    relationPhysicalShopId?: number;
    /**
     * Name of the store associated with the online store
     */
    relationPhysicalShopName?: string;
    /**
     * Physical warehouse id
     */
    physicalWarehouseId?: number;
    /**
     * List of virtual warehouse
     */
    virtualWarehouses?: Array<VirtualWarehouseDTO>;
    /**
     * Connection status of the channel integration
     */
    connectionStatus?: OnlineShopDetailVO.ConnectionStatusEnum;
    /**
     * Webhook secret
     */
    webhookSecret?: string;
}
export namespace OnlineShopDetailVO {
    export const ConnectionStatusEnum = {
        Connected: 'CONNECTED',
        NotConnected: 'NOT_CONNECTED',
        TempError: 'TEMP_ERROR'
    } as const;
    export type ConnectionStatusEnum = typeof ConnectionStatusEnum[keyof typeof ConnectionStatusEnum];
}


